import React from "react";
import { UrlProvider } from "../../../../../api/UrlProvider";
import SquaberLink from "../../SquaberLink";
import withTranslations from "../../../../../hocs/withTranslations";
import { compose } from "redux";
import useIsDesktop from "../../../landingPage/hooks/useIsDesktop";
import classNames from "classnames";

const Ticker = ({ market, ticker, locale }) => {
  const isDesktop = useIsDesktop();

  return (
    <div className={"flex gap-2.5"}>
      {ticker && (
        <SquaberLink
          to={UrlProvider.getUrl("fe.stockPage", {
            locale,
            marketId: market,
            stockId: ticker
          })}
          className={classNames(
            "line-height-130 font-bold text-black no-underline",
            {
              "text-5xl": isDesktop,
              "text-3xl.1": !isDesktop
            }
          )}
        >
          {ticker}
        </SquaberLink>
      )}
      {market && (
        <div className={classNames("line-height-130 font-medium text-black-9", {
          "text-xs": isDesktop,
          "text-xs.1": !isDesktop
        })}>
          {market}
        </div>
      )}
    </div>
  );
};

export default compose(withTranslations)(Ticker);
